import {host} from "~/utils/constants";

export class BlogArticle{
    id = 0
    Title = ""
    Description = ""
    Content = ""
    Featured= false
    ImageUrl = ""
    publishedAt= new Date()
    category= {
        id: 0,
        name: ""
    }

    parseJson(ret: { id: number; attributes: { [key: string]: any } }) {
        console.log(ret)
        this.id = ret.id;
        this.Title = ret.attributes.Title
        this.Description = ret.attributes.Description
        this.Content = ret.attributes.Content
        this.Featured = ret.attributes.Featured
        this.publishedAt = new Date(ret.attributes.publishedAt)
        if(ret.attributes.Image && ret.attributes.Image.data){
            this.ImageUrl = host + ret.attributes.Image.data.attributes.url
        }

    }
    toJSON () {
        return {...this}
    }
}